import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExperiencesService } from "@services/experience/experiences.service";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";
import { ExperienceCountService } from "@services/experience/experience-count.service";
import { ErrorEmitterService } from "@services/emitters/error-emitter.service";
@Component({
  selector: "app-getting-started",
  templateUrl: "./getting-started.component.html",
  styleUrls: ["./getting-started.component.scss"],
})
export class GettingStartedComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public loader: boolean = false;
  constructor(
    private experienceSvc: ExperiencesService,
    private experienceCountSvc: ExperienceCountService,
    private errorEmitter: ErrorEmitterService,
    private router: Router
  ) {}
  
  ngOnInit() {
    this.experienceSvc
            .getExperienceCount()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(
              (x) => {
                if (x.draftVersionsCount > 0) {
                  this.experienceCountSvc.sendCount(x);
                }
                this.experienceCountSvc.sendCount(x);
              },
              (err) => {
                this.errorEmitter.sendError(true);
              }
            );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
